// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

export enum JobType {
  Device,
  Road,
  Geofence
}

export enum JobPlatform {
  Web = 1,
  Mobile
}

export enum JobStatus {
  Pending = 0,
  Processing = 1,
  Successful = 2,
  Failed,
  Due,
  Disabled,
  Paused,
  Stopped = 7
}
export enum TaskStatus {
  Pending = 0,
  Uploading = 1,
  UploadingKV = 7,//
  Stitching = 9,//
  Paused = 3,
  Stopped = 6,
  Successful = 2,//
  WaitForStitching = 10,
  Stitched = 11,//
  // Successful = 8,
}

export enum AllStages {
  'Not Stared',
  'In Progress',
  'Completed'
}
export const stageAndStatus = {
  [AllStages['Not Stared']]: [JobStatus.Pending],
  [AllStages['In Progress']]: [JobStatus.Processing],
  [AllStages['Completed']]: [
    JobStatus.Stopped,
    JobStatus.Successful,
    JobStatus.Failed,
    JobStatus.Paused,
    JobStatus.Disabled
  ]
}

export const uploadTypeDictionary = [
  { label: 'Camera', value: 0 },
  { label: 'Geofence', value: 2 }
]
export const platFormDictionary = [
  { label: 'Web', value: 1 },
  { label: 'Mobile', value: 2 }
]
export const jobStatusDictionary = [
  { label: 'Completed', value: [JobStatus.Successful] },
  { label: 'Stopped', value: [JobStatus.Stopped] }
]
export const deviceTypeDictionary = [
  { label: '360Lite', value: 1 },
  { label: 'Single', value: 0 }
]
